/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CambiarPasswordMedicoDto } from '../../models/cambiar-password-medico-dto';

export interface MedicosConfiguracionControllerCambiarPassword$Params {
  
    /**
     * Nueva contraseña del médico
     */
    body: CambiarPasswordMedicoDto
}

export function medicosConfiguracionControllerCambiarPassword(http: HttpClient, rootUrl: string, params: MedicosConfiguracionControllerCambiarPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, medicosConfiguracionControllerCambiarPassword.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

medicosConfiguracionControllerCambiarPassword.PATH = '/api/medicos-configuracion/cambiar-password';
